// Tracks state changing requests that are still in flight, keyed by record and action.
//
// The action buttons live inside table cells. Paging away and back unmounts and
// remounts those cells, which resets any loading flag held in component state and
// re-arms the button while the first request is still running. A second click then
// races the first. This guard lives outside the component tree so a remount cannot
// clear it.
const inFlight = new Set<string>()

const key = (recordId: string, action: string) => `${recordId}:${action}`

// Returns false when the same action is already running for this record
export const beginAction = (recordId: string, action: string) => {
    const actionKey = key(recordId, action)
    if (inFlight.has(actionKey)) return false
    inFlight.add(actionKey)
    return true
}

export const endAction = (recordId: string, action: string) => {
    inFlight.delete(key(recordId, action))
}

export const isActionInFlight = (recordId: string, action: string) => inFlight.has(key(recordId, action))

// Test seam, the set is module level and would otherwise leak between cases
export const resetActionGuard = () => inFlight.clear()

export const ACTION_IN_FLIGHT_MESSAGE =
    'That action is already being processed. Please wait for it to finish before trying again.'

// Falls back to something readable when the server could not say why it refused
export const UNKNOWN_ACTION_FAILURE =
    'The action could not be completed. Refresh the page to see the current status and try again.'
